// extracted by mini-css-extract-plugin
export default {"main":"Countdown_main__GwSV3","container":"Countdown_container__-1My0","h1":"Countdown_h1__5T5hQ","note":"Countdown_note__CIaJZ","p":"Countdown_p__3R1EA"};